import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { CurrentUserPreferencesFacade } from '@recruitee/account-logic';

import { KiwiHrPromoDashboardComponent } from '../kiwi-hr-promo-dashboard/kiwi-hr-promo-dashboard.component';
import { KiwiHrPromoAnalytics } from '../kiwi-hr-promo.analytics';
import { KiwiHrPromoService } from '../kiwi-hr-promo.service';

@Component({
  selector: 'rt-kiwi-hr-dashboard-widget',
  templateUrl: './kiwi-hr-dashboard-widget.component.html',
  styleUrl: './kiwi-hr-dashboard-widget.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [KiwiHrPromoDashboardComponent],
  providers: [KiwiHrPromoAnalytics],
})
export class KiwiHrDashboardWidgetComponent {
  private readonly currentUserPreferencesFacade = inject(CurrentUserPreferencesFacade);
  private readonly kiwiAnalytics = inject(KiwiHrPromoAnalytics);
  private readonly kiwiHrPromoService = inject(KiwiHrPromoService);

  protected readonly theme = toSignal(this.currentUserPreferencesFacade.effectiveThemeName$);

  protected onKiwiBannerClose(): void {
    this.kiwiAnalytics.trackBannerClose();
    this.kiwiHrPromoService.markAsClosed();
  }

  protected onKiwiBannerCtaClick(): void {
    this.kiwiAnalytics.trackBannerCtaClick();
    this.kiwiHrPromoService.open();
  }
}
